"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LanguageContext = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _schemaReducer = _interopRequireDefault(require("./schema-reducer"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  questionnaireBuilderTitle: "Questionnaire Builder",
  questionnaireDetailsTitle: "Details",
  questionnaireAddQuestions: "Add Questions",
  questionnaireDetailsTitleLabel: "Questionnaire Title",
  questionnaireDetailsDescriptionLabel: "Questionnaire Description",
  questionnaireInputTitleLabel: "Title",
  questionnaireInputDescriptionLabel: "Description",
  textFieldQuestion: "Open Ended",
  selectionQuestion: "Multiple choice",
  checkboxQuestion: "Check Box",
  questionTitleLabel: "Question",
  addOptionLabel: "Add Option",
  questionnaireSave: "Save",
  questionnairePreviewTitle: "Preview",
  questionContainerRequiredLabel: "Required",
  questionContainerHorizontalLabel: "Horizontal",
  questionAddQuestionLabel: "Add Question",
  questionCollapseAll: "Collapse All"
};

var Store = function Store(_ref) {
  var children = _ref.children,
      languageOptions = _ref.languageOptions;

  var _useReducer = (0, _react.useReducer)(_schemaReducer.default, _objectSpread(_objectSpread({}, initialState), languageOptions)),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return /*#__PURE__*/_react.default.createElement(LanguageContext.Provider, {
    value: [state, dispatch]
  }, children);
};

var LanguageContext = /*#__PURE__*/(0, _react.createContext)(initialState);
exports.LanguageContext = LanguageContext;
var _default = Store;
exports.default = _default;